import React, { Component } from 'react';
import {
    Layout,
    Input,
    Row,
    Col,
    List,
    message,
    Alert
} from 'antd';
import './SelecioneRadio.css';
import DataService from '../../Components/Data';

const { Header, Content } = Layout;
const Search = Input.Search;

class SelecioneRadio extends Component {

    constructor(props) {
        super(props);

        this.dataService = new DataService();

        this.state = {
            arrayRadios: [],
            loading: false,
            buscou: false
        }
    }

    buscaRadio(value) {

        if (value === "") {
            message.warning('Digite o nome da rádio');
            return
        }

        this.setState({
            loading: true,
            buscou: true
        });

        var dados = {
            "dsDNS": window.location.origin,
            "dsEstabelecimento": value
        };

        this.dataService.GetListaEstabelecimento(dados, (retorno) => {

            this.setState({
                arrayRadios: retorno,
                loading: false
            });

        }, (error) => {
            console.log(error);
            this.setState({
                loading: false
            });
        });
    }

    render() {

        return (

            <Layout className="App selecioneRadio" style={{ height: "100vh" }}>
                <Header className="App-header App-header-login" style={{ position: 'fixed', width: '100%', zIndex: 100 }}>
                    Selecione a Rádio
                </Header>
                <Content className="contentStyle">

                    <Row>
                        <Col>
                            <Search
                                placeholder="Digite o nome da rádio"
                                enterButton="Buscar"
                                size="large"
                                onSearch={value => this.buscaRadio(value)} />
                        </Col>
                    </Row>

                    {(this.state.buscou && !this.state.loading && this.state.arrayRadios.length === 0) &&
                        <Row className="resultRadios">
                            <Col>
                                <Alert message="Nenhuma rádio encontrada com os termos pesquisados" type="warning" />
                            </Col>
                        </Row>
                    }

                    {(this.state.buscou && (this.state.arrayRadios.length > 0 || this.state.loading) ) &&
                        <Row className="resultRadios">
                            <Col>
                                <List
                                    itemLayout="horizontal"
                                    dataSource={this.state.arrayRadios}
                                    bordered
                                    loading={this.state.loading}
                                    renderItem={item => (
                                        <List.Item>
                                            <List.Item.Meta
                                                title={<a href={"./login?uiFilial=" + item["UiFilial"]}>{item["DsEstabelecimento"]}</a>}
                                            />
                                        </List.Item>
                                    )}
                                />
                            </Col>
                        </Row>
                    }
                </Content>

            </Layout>
        )
    }
}

export default SelecioneRadio;


// WEBPACK FOOTER //
// ./src/Pages/SelecioneRadio/SelecioneRadio.js